import { ProviderErrorResponse } from '@apis/auth';
import { setProviderIssue } from './providerStatus.slice';

/**
 * Maps a query error to the reconnect action to dispatch — or `null` if the
 * error isn't a provider error. The QueryClient's `onError` (main.tsx) runs this
 * on every query failure to flip the global reconnect chip reactively, the
 * moment a provider-backed request hits a dead/absent session.
 *
 * `PROVIDER_NOT_CONNECTED` → never connected; `PROVIDER_DISCONNECTED` and Genba's
 * `PROVIDER_REAUTH_REQUIRED` (a 401 — Genba has no refresh) → needs reconnect.
 */
export function providerIssueAction(error: unknown) {
  if (!(error instanceof ProviderErrorResponse)) return null;
  return setProviderIssue({
    provider: error.provider,
    issue: error.code === 'PROVIDER_NOT_CONNECTED' ? 'not-connected' : 'disconnected',
  });
}
